export default __webpack_public_path__ + "static/media/46.b97e6804.png";